<style scoped> 
    .label-custom{
        font-weight: 600;
        font-style: italic;
    }
</style>

<template>
    <div :class="['mb-4', divGridClass]">
        <div class="form-group mb-2 mb-md-0">
            <div style="display: flex; align-items: center; gap: 4px;">
                <div style="width: 95%;">
                    <app-input
                        type="search-select"
                        v-model="selected"
                        :required="required" 
                        :placeholder="'Select ' + label"
                        :list="list"
                        :disabled="is_view"
                    />
                </div>
                <div style="width: 5%; text-align: center;">
                    <button
                        v-if="value && !is_view"
                        type="button"
                        @click="clearSelection"
                        style="background: none; border: none; cursor: pointer; color: #6c757d; font-size: 16px; padding: 0; width: 100%;"
                    >
                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'SelectCustom',
    props: {
        divGridClass : {
            type : String,
            default : 'col-md-4',
        },
        value: {
            type: [String, Number, Object],
            default: null
        },
        list: {
            type: Array,
            required: true
        },
        is_view : {
            type : Boolean,
            default : false,
        },
        label : {
            type: String,
            default : '',
        },
        required : {
            type : Boolean,
            default : false,
        }
    },
    methods: {
        clearSelection() {
            this.$emit('input', null);
        }
    },
    computed: {
        selected: {
            get() {
                return (this.value && typeof this.value === 'object') ? this.value.id : this.value;
            },
            set(newValue) {
                const fullObject = this.list.find(item => item.id === newValue);
                this.$emit('input', fullObject);
            }
        }
    }
}
</script>